// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__24fIT","label":"Section_label__2syfS","contentWrap":"Section_contentWrap__JJgKx","footer":"Section_footer__36_jr","footerInner":"Section_footerInner__2__Sb"};